module.exports = __webpack_public_path__ + "static/media/rotate-clock.997dbe27.svg";